import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getStory} from "../../actions/Story";
import HtmlParser from "../Common/HtmlParser";
import BreadCrumbs from "../Common/BreadCrumbs";
import {Loader} from "../Common/Loader";
import {getTagClickDetailLocalStorage} from "../../actions/Common";
import {eventTracking} from "../../actions/UserAction";

class Story extends Component {
    constructor(props) {
        super(props);
        this.state = {
            breadCrumbs : [{
                id: "dashboard",
                text: "My earthDECK"
            },
            {
                id: getTagClickDetailLocalStorage(),
                text: getTagClickDetailLocalStorage()
            }]
        };
        this.backSpaceFunction = this.backSpaceFunction.bind(this);
    }

    componentWillReceiveProps(prevProps) {
        // only update chart if the data has changed
        this.state = {
            showLoader: false,
            breadCrumbs: [
							{
                id: "dashboard",
                text: "My earthDECK"
            	},
            	{
                id: getTagClickDetailLocalStorage().tagId,
                text: getTagClickDetailLocalStorage().tagName
            	},
            	{
                id: prevProps.match.params.storyId,
                text: prevProps.storyData.title
							}
						]
        };
      }

    componentWillMount() {
        const storyId = this.props.match.params.storyId;
        this.setState({ showLoader: true });

        this.props.getStory(storyId, (response) =>{
            //this.setState({ showLoader: false });
        });

    }

    /* Code for checking backspace press on story detail page */
    backSpaceFunction(event){
      /* Action tracking */
      if(event.keyCode == 8) {
        let originRoute = document.referrer;
        let destinationRoute = window.location.href;
        let date = new Date();
        let postData = {type: 'StoryBackSelected', originRoute: originRoute, destinationRoute: destinationRoute, timestamp: date};
        this.props.eventTracking(postData);
      }
      /* Action tracking */
    }
    componentDidMount(){
      document.addEventListener("keydown", this.backSpaceFunction, false);
    }
    componentWillUnmount(){
      document.removeEventListener("keydown", this.backSpaceFunction, false);
    }
    /* Code for checking backspace press on story detail page */

    renderMap() {
        if(this.props.storyData.map){
            return (
                <div className="map m-t50">
                    <img src="/assets/images/eathdeck/map_image.png" />
                </div>
            );
        }
    }

    renderContactInformation() {
        if(!_.isEmpty(this.props.storyData.contact)){
            return (
                <div className="medium-6 columns">
                    <div className="shadow-box box-padding match-height">
                        <h2 className="page-heading m-t0">For more information contact</h2>
                        <div className="section-address">
                            <p><span className="address-icon"><img src="/assets/images/eathdeck/phone.png" /></span><span></span></p>
                        </div>
                    </div>
                </div>
            );
        }
    }

  renderStoryItem () {
    // console.log(this.props.storyData)
    if (!this.props.storyData) {
        return null;
    }
    
    let bgPoster = this.props.storyData.poster;
    
    return(
        <section className="project-detail">
						<div className="project-banner">
							<div className="banner-container">
								<img src={bgPoster}/>
							</div>
							<div className="row detail-heading">
								<div className=" medium-12 columns">
									<h1 className="page-heading">{this.props.storyData.title}</h1>
									<p dangerouslySetInnerHTML={{__html: this.props.storyData.subTitle}}></p>
								</div>
							</div>
            </div>
            <div className="clearfix"></div>
            <div className="row">
                <div className="medium-12 columns">
                    <BreadCrumbs breads={this.state.breadCrumbs} />
                </div>
            </div>
            
            <div className="row m-t15">
                <div className="medium-12 columns p-t20">
                    <div className="shadow-box box-padding">
                        <div className="detail-content">
                            <HtmlParser content={this.props.storyData.description}/>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="row m-t20">
                <div className="medium-12 columns">
                    <div className="shadow-box box-padding detail-content">
                        <div className="tag-detail"><i className="icon-tag-black-shape"></i>&nbsp;
                            {this.props.storyData.tags.map((tag, index)=>{
                            return  <span key={`tag_${index}`}>
                                { (index ? ', ' : '') }
                                <a href={`/dashboard/${tag.tagId}/${tag.tagName}`} className="first-upper">{tag.tagName}</a>
                            </span>;
                            })}
                        </div>
                    </div>
                </div>
            </div>

            <div className="row m-t20">
                <div className="medium-12 columns">
                    <div className="shadow-box box-padding detail-content">
                        <h2 className="page-heading m-t0">References</h2>
                        <ul className="medium-block-grid-12">
                            {this.props.storyData.resources.map((resource, index)=>{
                                return <li key={`resource${index}`}>
                                    <a target="_blank" href={`${resource.url}`}>{resource.number}</a>
                                </li>;
                            })}
                        </ul>
                    </div>
                </div>
                            
                {this.renderContactInformation()}

            </div>
            {this.renderMap()}
        </section>
    );
  }

  render() {
    const {storyData} = this.props;
    if(!this.state.showLoader) {
			return(
        <div>
					{this.renderStoryItem()}
        </div>
			);
    } else {
			return <Loader/>
    }
  }
}


const mapStateToProps = ({story}) => {
	const {storyData} = story;

	if (storyData && storyData.resources) {
		storyData.resources.forEach(({url, number}) => {
			const referenceString = `[${number}]`;
			const replaceRegExp = new RegExp(`\\[${number}\\]`, 'g');
			const newReferenceText = `<a href="${url}" target="_blank">${referenceString}</a>`;
	
			storyData.subTitle = storyData.subTitle.replace(replaceRegExp, newReferenceText);
			storyData.description = storyData.description.replace(replaceRegExp, newReferenceText);
		});
	}

  return {storyData};
}

//Connect action to component
export default connect(mapStateToProps, {getStory, eventTracking})(Story);



// WEBPACK FOOTER //
// ./components/Story/Story.js